/* eslint-disable indent */
/* eslint-disable camelcase */
import * as types from '@/store/mutation-types'
import axios from 'axios'

export const actions = {
    async getLocationImages({ rootGetters, commit }, { locationId }) {
        let url = `${rootGetters['permissions/url']}/location_images/${locationId}`
        let headers = {
            ...rootGetters['permissions/details'].api_headers,
            'auth-token': rootGetters['auth/user'].token
        }
        // console.log(locationId)

        let response = await axios.get(url, { headers })
        console.log(response)
        commit(types.SET_LOCATION_IMAGES, response.data.payload)
        return response
    },

    async addLocationImage({ rootGetters, commit }, { data }) {
        let url = `${rootGetters['permissions/url']}/location_images/`
        let headers = {
            ...rootGetters['permissions/details'].api_headers,
            'auth-token': rootGetters['auth/user'].token
        }

        let response = await axios.post(url, data, { headers })
        console.log(response)
        return response
    }
}
export default actions
